import axios from "axios";
import { configUrl } from "../config";

const medineerHelpSupportNotificationService = async (payload) => {
    try {
        const response = await axios.post(`${configUrl.AssessmentServer}/api/Coupon/medineerHelpSupportNotification`,
            payload
        );

        return response.data;
    } catch (error) {
        console.error("Help & Support API Error:", error);

        throw error;
    }
};

export default medineerHelpSupportNotificationService;